

















































































import { defineComponent, ref, computed } from '@vue/composition-api';
import { i18n } from './../../../../i18n';
import qrCodePreview from '@/components/common/qr-code-preview/index.vue';
import { useAllowlist } from '@tt4b/ttam-hooks';
import { Message } from 'byted-vui';
const prefix = 'tt_deeplink:';
const startWithStrArr = ['sslocal://', 'aweme://', 'http://'];
const name = 'ttam-creative-deeplink-preview-dialog';

export default defineComponent({
  name,
  components: {
    qrCodePreview,
  },
  props: {
    deepLink: {
      type: String,
      default: '',
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { isUtmBuilderWhite } = useAllowlist();
    const dialogVisible = ref(props.visible);
    const handlePreviewClose = () => {
      emit('close');
      dialogVisible.value = false;
    };
    const handlePreviewShow = () => {
      dialogVisible.value = true;
    };
    const isStartWithSpec = () => startWithStrArr.some(item => props.deepLink?.startsWith(item));
    const deepLinkAddPrefix = computed(() => (isStartWithSpec() ? props.deepLink : prefix + props.deepLink));

    const qrPreviewBg = ref();
    const qrCode = ref();
    const qrBox = ref();

    // const handleCopyQrCode = () => {
    //   console.log(qrPreviewBg.value);
    // };

    const handleCopyQrCode = () => {
      const newCanvas: any = document.getElementById('deeplink-canvas');
      const ctx = newCanvas.getContext('2d') as CanvasRenderingContext2D;
      // 绘制canvas背景
      ctx.drawImage(qrPreviewBg.value, 0, 0, 912, 360);
      const qrImg = qrCode.value && qrCode.value.$children[0]?.$el;
      if (!qrImg) {
        return;
      }
      // 绘制二维码图片
      ctx.drawImage(qrImg, 80, 48, 264, 264);
      // 绘制文字
      ctx.font = '500 24px PingFang SC';
      ctx.fillStyle = 'white';
      const text = i18n.t('module_ad_deep_link_check_dialog_content_tips') as string;
      const arrText = text.split('');
      let line = '';
      let y = 80;
      // 处理文字断行
      for (let n = 0; n < arrText.length; n++) {
        const textLine = line + arrText[n];
        const metrics = ctx.measureText(textLine);
        const textWidth = metrics.width;
        if (textWidth > 440 && n > 0) {
          ctx.fillText(line, 384, y);
          line = arrText[n];
          y += 44;
        } else {
          line = textLine;
        }
      }
      ctx.fillText(line, 384, y);
      // 复制到剪切板
      newCanvas.toBlob(async blob => {
        try {
          await (window.navigator.clipboard as any)
            .write([new (window as any).ClipboardItem({ 'image/png': blob })])
            .then(() => {
              Message.success(`${i18n.t('module_dashboard_creative_preview_copy_qrcode_success')}`);
            });
        } catch (err) {
          Message.error(err as any);
        }
      });
    };

    return {
      name,
      deepLinkAddPrefix,
      qrPreviewBg,
      dialogVisible,
      qrCode,
      qrBox,
      handleCopyQrCode,
      handlePreviewShow,
      handlePreviewClose,
      isUtmBuilderWhite,
    };
  },
});
